// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__TUMUP","modal":"Modal_modal__0nTx0","slide-down":"Modal_slide-down__x+GJp"};